import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingStatusCell, renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpTable } from '~/design-system';
const columns = [
    { key: 'id', label: 'ID', width: 88, minWidth: 72, resizable: true },
    { key: 'title', label: 'Title', width: 220, minWidth: 180, resizable: true },
    { key: 'partnerId', label: 'Partner ID', width: 104, minWidth: 88, resizable: true },
    { key: 'summary', label: 'Summary', width: 280, minWidth: 220, resizable: true },
    { key: 'status', label: 'Status', width: 128, minWidth: 104, resizable: true },
    { key: 'actions', label: 'Actions', align: 'center', width: 112, minWidth: 96, required: true },
];
export function renderCreativesTable() {
    return renderKoDataTable({
        title: 'Creatives',
        titleIcon: 'image',
        caption: 'Creative assets',
        columns,
        className: 'creatives-table',
        children: renderCreativesBody(),
    });
}
function renderCreativesBody() {
    return html `
        ${LpTable.Body({
        attributes: { 'data-bind': 'foreach: creatives' },
        children: LpTable.Row({
            children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'id' })}
                    ${renderRecruitingTextCell({ column: columns[1], binding: '$data.title || $data.partnerTitle || $data.name || ""', titleBinding: '$data.title || $data.partnerTitle || $data.name || ""' })}
                    ${renderRecruitingTextCell({ column: columns[2], binding: '$data.partnerId || $data.partner_id || ""' })}
                    ${renderRecruitingTextCell({ column: columns[3], binding: '$data.descShortLabel || $data.descShort || $data.shortDescription || ""', clampLines: 3, titleBinding: '$data.descShortLabel || $data.descShort || $data.shortDescription || ""' })}
                    ${renderRecruitingStatusCell({
                column: columns[4],
                textBinding: 'statusLabel',
                cssBinding: `
                            'task-status--success': statusValue === 1,
                            'task-status--pending': statusValue === 0,
                            'task-status--neutral': statusValue === 2
                        `,
            })}
                    ${LpTable.Cell({
                column: columns[5],
                className: 'creatives-table__actions',
                children: html `
                            <div class="list-page-row-actions">
                                ${LpButton({ ariaLabel: 'Edit', prefixIcon: 'pencil-simple', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickEdit' } })}
                                ${LpButton({ ariaLabel: 'Duplicate', prefixIcon: 'copy', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickDuplicate' } })}
                            </div>
                        `,
            })}
                `,
        }),
    })}
        ${renderKoEmptyState({ colSpan: columns.length, visibleBinding: 'creatives().length === 0', title: 'No creatives found', description: 'Create a creative to start adding partner assets.', icon: 'image' })}
    `;
}
